const inferSection = (attempt) => {
  if (attempt?.section) return attempt.section;

  const id = String(attempt?.diagnosticId || attempt?.id || "").toLowerCase();
  if (id.includes("math")) return "Math";
  if (id.includes("english")) return "English";
  return "Diagnostic";
};

const computeCounts = (attempt) => {
  const responses = attempt?.responses || {};
  const responseEntries = Object.values(responses);

  const correct = responseEntries.reduce(
    (sum, r) => sum + (r?.correct ? 1 : 0),
    0
  );

  const total =
    attempt?.administeredCount ??
    (Array.isArray(attempt?.sequence) ? attempt.sequence.length : null) ??
    responseEntries.length;

  const safeTotal = Number.isFinite(total) ? total : responseEntries.length;
  const incorrect = Math.max(0, safeTotal - correct);

  return { correct, incorrect, total: safeTotal };
};

const titleFromSection = (section) => {
  if (section === "Math") return "SAT Math Diagnostic";
  if (section === "English") return "SAT English Diagnostic";
  return "SAT Diagnostic";
};

export function convertDiagnosticToAssignment(attemptDocId, attemptData) {
  const attempt = { id: attemptDocId, ...(attemptData || {}) };

  const section = inferSection(attempt);
  const { correct, incorrect, total } = computeCounts(attempt);

  const createdAtDate = attempt.createdAt?.toDate?.() ?? null;

  const status =
    attempt.status === "completed"
      ? "Complete"
      : attempt.status === "in_progress"
      ? "In Progress"
      : "Not Attempted";

  const title = titleFromSection(section);

  return {
    // IDs / type
    id: `diagnostic:${attemptDocId}`,
    type: "diagnostic",

    // These mirror assignment objects you already produce
    category: section,
    title,
    subtitle: `${total} Questions`,
    assignedDate: createdAtDate ? createdAtDate.toLocaleDateString() : "",

    // HARDENING: include the raw fields AssignmentCardsRow might use
    section,                 // some UIs use `section`
    packetName: title,       // matches assignment source naming
    questionCount: total,    // matches assignment source naming

    // timestamps (many UIs sort or display using these)
    assignedAt: attempt.createdAt ?? null,
    lastSavedAt: attempt.lastSavedAt ?? null,

    // stats
    status,
    correct,
    incorrect,

    // behavior flags
    reviewMode: attempt.status === "completed",
    simpleView: false,

    // metadata for later review mode wiring
    diagnosticAttemptId: attemptDocId,
    diagnosticId: attempt.diagnosticId ?? attemptDocId,
  };
}
